import AbstractNetworkStatus from '../all/AbstractNetworkStatus';
import PlaystationWebmaf from './PlaystationWebmaf';
import logger from 'src/utils/logger/logger';

class Ps4NetworkStatus extends AbstractNetworkStatus {

  constructor() {
    super();
    this.initListenerNetwork = this.initListenerNetwork.bind(this);
    this.initListenerNetwork();
  }

  isOnline() {
    logger.debug('[NetworkStatus] checking PS4...');
    return new Promise((resolve, reject) => {
      resolve(this.onLine);
    });
  }

  initListenerNetwork() {
    try {
      PlaystationWebmaf.addEventListener("networkStatusChange", (networkStatus) => {
        if (networkStatus && networkStatus.newState) {
          logger.info("[PS4] Received the network status change callback> ", networkStatus.newState);
          if (networkStatus.newState === "connected") {
            this.onLine  = true;
          } else if (networkStatus.newState === "disconnected") {
            this.onLine  = false;
          }
        }
      });
    }
    catch(e) {
      logger.error("[NetworkStatus] PS4 Unable to init network status listener> " + e);
    }
  }
}

export default Ps4NetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/ps4/NetworkStatus.js